import {
    IconUserCircle,
    IconMap,
    IconDeviceLandlinePhone,
    IconBuildings,
    IconIdBadge2,
    IconClock,
} from '@tabler/icons-react';

export const NavIcons = {
    IconUserCircle: (): JSX.Element => <IconUserCircle size={20} />,
    IconMap: (): JSX.Element => <IconMap size={20} />,
    IconDeviceLandlinePhone: (): JSX.Element => <IconDeviceLandlinePhone size={20} />,
    IconBuildings: (): JSX.Element => <IconBuildings size={20} />,
    IconBadge: (): JSX.Element => <IconIdBadge2 size={20} />,
    IconClock: (): JSX.Element => <IconClock size={20} />,
};
